/**
 * A module's chapters as a segmented bar (the mockup's chapter bar): one segment per chapter, green
 * where complete, the accent on the chapter the learner has saved as their place, the quiet track
 * elsewhere. It is decoration for sighted readers; the line beside it always says the same thing in
 * words ("0 of 9 chapters complete · 0%"), so it is hidden from assistive technology.
 */
export function SegmentBar({
  total,
  complete,
  place = null,
  className = '',
  thin = false,
}: {
  total: number;
  complete: number;
  place?: number | null;
  className?: string;
  /** The player bar's hairline version. */
  thin?: boolean;
}) {
  if (total <= 0) return null;
  return (
    <span
      aria-hidden="true"
      data-segment-bar=""
      data-segments={total}
      data-complete={complete}
      data-place={place ?? ''}
      className={`flex gap-1 ${className}`}
    >
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          className={`${thin ? 'h-[3px]' : 'h-[5px]'} min-w-0 flex-1 rounded-full ${
            i < complete ? 'bg-success' : i === place ? 'bg-accent' : 'bg-chip'
          }`}
        />
      ))}
    </span>
  );
}
